import ValidationType from '../ValidationType';

class ValidEmailAddress extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    const errors = [];
    const currentValue = fieldResponse.currentValue || '';

    /**
     * NOTE: This regex, as with any email regex, is incomplete, and should not be relied upon for full validation.
     *
     * @see https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
     */
    const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    const mailToRegex = /^(mailto:)/i;
    if (currentValue && !emailRegex.test(currentValue)) {
      errors.push(this._createError(fieldResponse, currentValue));
    } else if (currentValue && mailToRegex.test(currentValue)) {
      // Error added explicitly for emails beginning with `mailto:`
      errors.push(this._createError(fieldResponse, currentValue));
    }

    return errors;
  }

  _createError(fieldResponse, value) {
    return this.createValidationError({
      fieldResponse,
      key: 'ERROR_VALID_EMAIL_ADDRESS',
      values: { value },
      message: `Value '${value}' is not a valid email address`,
    });
  }
}

export default ValidEmailAddress;
